import * as React from "react"
import { LucideChevronDown } from "lucide-react"
import { cn } from "../../lib/utils"

const AccordionContext = React.createContext<{
  activeValue?: string;
  setActiveValue: (value: string) => void;
} | null>(null);

export const Accordion = ({ children, className }: any) => {
  const [activeValue, setActiveValue] = React.useState<string>("");
  return (
    <AccordionContext.Provider value={{ activeValue, setActiveValue }}>
      <div className={cn("w-full", className)}>{children}</div>
    </AccordionContext.Provider>
  );
};

export const AccordionItem = ({ value, title, children, className }: any) => {
  return (
    <div className={cn("border-b", className)} data-state={value === value ? "open" : "closed"}>
      {/* We pass the value down to children via React.Children or Context */}
      {React.Children.map(children, child => 
        React.isValidElement(child) ? React.cloneElement(child as any, { value }) : child
      )}
    </div>
  );
};

export const AccordionTrigger = ({ children, className, value }: any) => {
  const context = React.useContext(AccordionContext);
  const isOpen = context?.activeValue === value;

  return (
    <button
      onClick={() => context?.setActiveValue(isOpen ? "" : value)}
      className={cn("flex w-full items-center justify-between py-4 font-medium transition-all", className)}
    >
      {children}
      <LucideChevronDown className={cn("h-4 w-4 transition-transform duration-200", isOpen && "rotate-180")} />
    </button>
  );
};

export const AccordionContent = ({ children, className, value }: any) => {
  const context = React.useContext(AccordionContext);
  const isOpen = context?.activeValue === value;

  return (
    <div className={cn(
      "overflow-hidden transition-all duration-300",
      isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0",
      className
    )}>
      {children}
    </div>
  );
};